exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".ellipsis-cell{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-clamp:2;overflow:hidden;text-overflow:ellipsis;width:100%;line-height:1.5}", "", {"version":3,"sources":["/workspace/src/views/audit-intern/pages/AuditInternTable.vue"],"names":[],"mappings":"AACA,eAAe,oBAAoB,4BAA4B,qBAAqB,aAAa,gBAAgB,uBAAuB,WAAW,eAAe,CACjK","file":"AuditInternTable.vue","sourcesContent":["\n.ellipsis-cell{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-clamp:2;overflow:hidden;text-overflow:ellipsis;width:100%;line-height:1.5\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-82c3cbb2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/audit-intern/pages/AuditInternTable.vue
// module id = 3189
// module chunks = 215